// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1FuNr","productName":"Table_productName__-x3Y_"};